var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rocket_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.118 4.602s-8.784-3.4-14.319 6.022c0 0 5.371-2.408 8.846.464 0 0 1.638-3.546 5.474-6.488zM31.375 19.86s3.402 8.784-6.022 14.319c0 0 2.408-5.372-.464-8.846 0 0 3.547-1.639 6.486-5.473"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__b)",
  d: "m19.185 26.347-5.135 5.135a.55.55 0 0 1-.776 0l-8.756-8.757a.55.55 0 0 1 0-.775l5.135-5.135z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__c)",
  d: "m8.6 17.867-3.953 3.952 9.533 9.533 3.953-3.953z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__d)",
  d: "M26.158 26.587c-2.504 2.224-5.378 3.963-8.486 5.07a2.38 2.38 0 0 1-1.882-.146 2.5 2.5 0 0 1-.657-.474l-10.17-10.17a2.5 2.5 0 0 1-.473-.656 2.37 2.37 0 0 1-.168-1.807.3.3 0 0 1 .02-.076c1.109-3.108 2.847-5.982 5.071-8.486a28.5 28.5 0 0 1 3.723-3.508l.01-.01A29.53 29.53 0 0 1 26.276.448c2.505-.445 5.11-.57 7.754-.32.96.091 1.75.88 1.84 1.84.912 9.664-3.134 18.8-9.713 24.62"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__e)",
  d: "M24.027 22.745a8.044 8.044 0 1 0 0-16.089 8.044 8.044 0 0 0 0 16.09",
  style: {
    mixBlendMode: "soft-light"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__f)",
  d: "M34.339 4.841c-3.226 4.934-10.731 2.048-12.825 2.94-2.095.893-3.386 2.29-3.386 2.29l-1.87-2.628s7.643-2.772 10.697-2.684c3.052.088 7.383.083 7.383.083",
  opacity: 0.5,
  style: {
    mixBlendMode: "multiply"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__g)",
  d: "M26.363 20.517c-5.535 5.535-14.895 5.151-20.907-.862a17 17 0 0 1-1.133-1.252.3.3 0 0 1 .021-.075c1.107-3.109 2.846-5.982 5.07-8.486a28.5 28.5 0 0 1 3.36-3.219l13.74 13.74q-.074.08-.151.155"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__h)",
  d: "M26.252 20.628c-3.51 3.51-9.447 3.266-13.262-.549-3.81-3.81-4.394-10.028.145-13.746l.01-.01A29.55 29.55 0 0 1 26.276.448c2.505-.445 5.11-.57 7.754-.32.96.091 1.75.881 1.84 1.84-.847 6.638-11.64 3.3-17.668 6.033l8.048 12.628"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__i)",
  d: "M21.085 23.058c-2.811.294-5.827-.711-8.095-2.979-3.81-3.81-4.394-10.027.145-13.746l.01-.009.089-.07c3.766 3.36 5.827 5.794 7.505 10.495.53 1.488 1.143 4.793.345 6.31z",
  opacity: 0.5,
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__j)",
  d: "M26.363 20.517a13 13 0 0 1-2.312 1.876c-.843.534-1.752.973-2.705 1.308-.952.334-1.95.561-2.97.682-1.02.12-2.06.136-3.1.03a15.8 15.8 0 0 1-6.034-1.875 16.2 16.2 0 0 1-2.66-1.824c-.203-.179-.407-.355-.606-.537q-.293-.28-.58-.564-.567-.58-1.073-1.21.517.623 1.09 1.193c.194.188.392.37.587.555.201.179.408.35.611.527a16.4 16.4 0 0 0 4.105 2.475l.368.15.093.038.093.034.186.067.374.133c.125.042.252.078.377.117 1.007.309 2.038.514 3.07.613 2.066.2 4.134-.04 6.034-.69a13.402 13.402 0 0 0 5.052-3.098",
  style: {
    mixBlendMode: "overlay"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__k)",
  d: "M18.184 7.98C22.559 2.517 29.301-.197 34.03.128c.96.09 1.75.88 1.84 1.84-.847 6.636-11.66 3.28-17.688 6.011z",
  style: {
    mixBlendMode: "soft-light"
  }
}), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__l)",
  d: "M20.77 22.924a7.695 7.695 0 1 0 0-15.39 7.695 7.695 0 0 0 0 15.39"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__m)",
  d: "M25.536 19.995a6.74 6.74 0 1 1-9.531-9.532 6.74 6.74 0 0 1 11.49 4.29 6.72 6.72 0 0 1-1.958 5.242"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.92 17.784h-6.734c-.451 0-.576-.622-.159-.795l3.417-1.427-1.212-2.235a.443.443 0 0 1 .39-.654h6.734c.451 0 .576.621.159.794l-3.417 1.427 1.212 2.234a.443.443 0 0 1-.39.655"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__n)",
  d: "M27.494 14.752c-3.941 2.07-8.928 1.449-12.242-1.865a11 11 0 0 1-.55-.594 6.74 6.74 0 0 1 12.793 2.459",
  style: {
    mixBlendMode: "soft-light"
  }
}), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__o)",
  d: "m8.15 33.711-.041.041c-1.058 1.034-2.742 1.789-3.917 2.226-.333.125-.6-.293-.349-.544l2.06-2.06a.476.476 0 0 0-.595-.734l-4.246 2.757c-.3.195-.653-.158-.458-.458l2.757-4.246a.476.476 0 0 0-.734-.596l-2.06 2.06c-.251.252-.669-.016-.544-.348.437-1.175 1.192-2.859 2.226-3.917l.04-.041a4.143 4.143 0 1 1 5.861 5.86"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#rocket_svg__p)",
  d: "m8.15 33.711-.04.041c-1.059 1.034-2.743 1.789-3.918 2.226-.332.125-.6-.293-.348-.544l2.06-2.06a.475.475 0 0 0-.596-.735l-4.245 2.758a.32.32 0 0 1-.415-.043l4.391-4.391c2.498-2.498 4.512-.902 4.22.753a4.13 4.13 0 0 1-1.108 1.995",
  style: {
    mixBlendMode: "overlay"
  }
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__b",
  x1: 4.836,
  x2: 16.255,
  y1: 17.521,
  y2: 28.939,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5433FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#20BDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#29F0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5433FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__c",
  x1: 9.413,
  x2: 12.089,
  y1: 26.587,
  y2: 23.911,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__d",
  x1: 41.846,
  x2: -10.207,
  y1: 22.636,
  y2: 1.563,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5433FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.438,
  stopColor: "#20BDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A5FECB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__f",
  x1: 31.459,
  x2: 16.728,
  y1: -0.12,
  y2: 15.051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__g",
  x1: 15.847,
  x2: 14.936,
  y1: 27.998,
  y2: 9.696,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5433FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#20BDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2EE6A9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__h",
  x1: 15.552,
  x2: 27.508,
  y1: 27.648,
  y2: -6.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5433FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#20BDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#06FFB6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__i",
  x1: 13.817,
  x2: 8.294,
  y1: 14.838,
  y2: 15.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__j",
  x1: 22.505,
  x2: 4.635,
  y1: 22.748,
  y2: 19.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__k",
  x1: 26.763,
  x2: 31.695,
  y1: 4.382,
  y2: 10.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__l",
  x1: 28.466,
  x2: 11.271,
  y1: 12.966,
  y2: 18.023,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5433FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#20BDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3EFFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__m",
  x1: 21.791,
  x2: 19.835,
  y1: 8.002,
  y2: 21.858,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB12B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AB8500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__n",
  x1: 20.205,
  x2: 23.439,
  y1: 8.897,
  y2: 25.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__o",
  x1: 8.719,
  x2: 0.785,
  y1: 27.761,
  y2: 34.612,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC400"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AB8500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "rocket_svg__p",
  x1: 10.066,
  x2: -5.287,
  y1: 29.191,
  y2: 43.099,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "rocket_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(5.68821 5.68836 -5.68821 5.68836 24.026 14.7)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "rocket_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export default SvgRocket;